import { render } from "./base-modal.vue?vue&type=template&id=39f85af0&scoped=true"
import script from "./base-modal.vue?vue&type=script&lang=js"
export * from "./base-modal.vue?vue&type=script&lang=js"

import "./base-modal.vue?vue&type=style&index=0&id=39f85af0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f85af0"]])

export default __exports__